import { render, staticRenderFns } from "./CustomLinksEditModal.vue?vue&type=template&id=ff750a3e&scoped=true"
import script from "./CustomLinksEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomLinksEditModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff750a3e",
  null
  
)

export default component.exports